import moment from 'moment-timezone';

const RANGES = [
	{ name: 'Past Week', amount: 7, unit: 'days' },
	{ name: 'Past Month', amount: 1, unit: 'months' },
	{ name: 'Past 3 Months', amount: 3, unit: 'months' },
	{ name: 'All', amount: 5, unit: 'years' },
];

/**
 * Fixed set of "look-back" ranges for the CrewLog time filter dropdown.
 * All boundaries are UTC ISO strings so they slot straight into the
 * `createdFromDateTime` / `createdToDateTime` filter shape.
 *
 * "All" uses a 5-year sentinel — treat it as "no lower bound".
 */
export const getUtcDateRangesCrewLogFilter = () => {
	const now = moment.utc();
	const endOfTodayUtc = now.clone().endOf('day').toISOString();

	return RANGES.map(({ name, amount, unit }) => ({
		name,
		value: {
			createdFromDateTime: now.clone().subtract(amount, unit).startOf('day').toISOString(),
			createdToDateTime: endOfTodayUtc,
		},
	}));
};
